import React from 'react';
import {FormattedMessage} from 'react-intl';
import Icon from 'components/Icon';

import styles from './EmbedViewDisabledHandler.css?module';

const EmbedViewDisabledHandler = () => (
  <div className={styles.container}>
    <div className={styles.message}>
      <Icon
        className={styles.inheritFont}
        icon={Icon.OPTIONS.CHAIN_UNLINKED}
        shade={Icon.SHADES.NONE}
      />
      <FormattedMessage
        id="EmbedViewDisabledHandler__NotFoundMessage"
        description="Message for when attempting to access a public card that no longer exists"
        defaultMessage="Sorry. This content is no longer available."
      />
    </div>
  </div>
);

export default EmbedViewDisabledHandler;
